import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Checkbox } from "../ui/checkbox";
import { Button } from "../ui/button";
import { toast } from "sonner";

export default function LeadTasksPanel({ leadId }) {
  const [tasks, setTasks] = useState([]);
  const [desc, setDesc] = useState("");
  const [due, setDue] = useState(new Date().toISOString().slice(0, 10));

  const load = () => api.get(`/crm/leads/${leadId}/tasks`).then((r) => setTasks(r.data));
  useEffect(() => {
    load();
  }, [leadId]);

  async function addTask() {
    if (!desc.trim()) return;
    try {
      await api.post(`/crm/leads/${leadId}/tasks`, { description: desc, due_date: due });
      setDesc("");
      load();
    } catch {
      toast.error("Cannot add task");
    }
  }

  async function toggle(t) {
    await api.put(`/crm/tasks/${t.id}`, { status: t.status === "done" ? "open" : "done" });
    load();
  }

  async function del(t) {
    await api.delete(`/crm/tasks/${t.id}`);
    load();
  }

  const todayIso = new Date().toISOString().slice(0, 10);

  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <Input value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Task description" data-testid="task-desc" />
        <Input type="date" value={due} onChange={(e) => setDue(e.target.value)} className="w-40" data-testid="task-due" />
        <Button onClick={addTask} className="bg-[#0D1B2A] text-white" data-testid="add-task-button">Add</Button>
      </div>
      {tasks.length === 0 ? (
        <p className="text-sm text-slate-500 py-4 text-center">No tasks yet.</p>
      ) : (
        <ul className="space-y-2">
          {tasks.map((t) => {
            const over = t.status === "open" && t.due_date < todayIso;
            const tod = t.status === "open" && t.due_date === todayIso;
            let border = "border-slate-200";
            if (over) border = "border-red-200 bg-red-50";
            else if (tod) border = "border-amber-200 bg-amber-50";
            let dueColor = "text-slate-500";
            if (over) dueColor = "text-[#DC2626]";
            else if (tod) dueColor = "text-amber-700";
            let dueSuffix = "";
            if (over) dueSuffix = " · overdue";
            else if (tod) dueSuffix = " · today";
            return (
              <li key={t.id} data-testid={`lead-task-${t.id}`}
                className={`flex items-center gap-3 p-3 border rounded ${border}`}>
                <Checkbox checked={t.status === "done"} onCheckedChange={() => toggle(t)} />
                <div className="flex-1">
                  <p className={`text-sm ${t.status === "done" ? "line-through text-slate-400" : "text-[#0D1B2A]"}`}>{t.description}</p>
                  <p className={`text-xs ${dueColor}`}>Due {t.due_date}{dueSuffix}</p>
                </div>
                <button type="button" onClick={() => del(t)} className="text-xs text-slate-400 hover:text-[#DC2626]">Delete</button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
